import { Info } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { usePrefs } from "@/lib/context";
import { NotificationBell } from "@/components/NotificationBell";
import { InstallAppButton } from "@/components/InstallApp";
import { GpsShareIndicator } from "@/components/GpsShare";
import { LANGS } from "@/lib/i18n";

const COMMON = ["EUR", "USD", "XAF", "XOF", "MAD", "GBP", "CHF", "CAD"];

function CurrencySwitcher() {
  const { currency, setCurrency, fx, t, fdatetime } = usePrefs();
  const all = Object.keys(fx?.rates || {}).sort();
  const list = [...COMMON.filter((c) => all.includes(c) || c === "EUR"), ...all.filter((c) => !COMMON.includes(c))];
  const rate = fx?.rates?.[currency];
  return (
    <div className="flex items-center gap-1.5">
      <Select value={currency} onValueChange={setCurrency}>
        <SelectTrigger className="h-8 w-[92px] rounded-sm font-data text-xs" data-testid="currency-switcher"><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-72">
          {list.map((c) => <SelectItem key={c} value={c} data-testid={`currency-option-${c}`} className="font-data text-xs">{c}</SelectItem>)}
        </SelectContent>
      </Select>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild><button data-testid="fx-info" className="text-slate-400 hover:text-[#996515]"><Info size={15} /></button></TooltipTrigger>
          <TooltipContent className="max-w-xs text-xs" data-testid="fx-info-content">
            <div>{t("rateInfo")} : 1 EUR = <span className="font-data">{rate ? rate.toFixed(4) : "—"}</span> {currency}</div>
            <div>{t("rateSource")} : {fx?.source || "—"}</div>
            <div>{t("rateDate")} : {fx?.date ? fdatetime(fx.date) : "—"}</div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}

export function TopBar({ mobileTrigger }) {
  const { lang, setLang } = usePrefs();
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-slate-200 bg-white/80 px-4 backdrop-blur-xl sm:px-8">
      <div className="flex items-center gap-3">
        {mobileTrigger}
        <span className="font-display text-sm font-bold tracking-[0.06em] sm:text-lg sm:tracking-[0.1em] lg:hidden">GESTIMMO</span>
      </div>
      <div className="flex items-center gap-2 sm:gap-3">
        <NotificationBell />
        <CurrencySwitcher />
        <GpsShareIndicator />
        <InstallAppButton />
        <Select value={lang} onValueChange={setLang}>
          <SelectTrigger className="h-8 w-[70px] rounded-sm px-2 text-[11px] font-bold uppercase" data-testid="lang-switcher"><SelectValue>{lang.toUpperCase()}</SelectValue></SelectTrigger>
          <SelectContent>{LANGS.map(([l, n]) => <SelectItem key={l} value={l} data-testid={`lang-${l}`}><span className="font-bold uppercase">{l}</span> <span className="text-slate-500">· {n}</span></SelectItem>)}</SelectContent>
        </Select>
      </div>
    </header>
  );
}
